import _ from 'underscore';
import templateStr from 'text!./edit-payroll.html';
import PayrollReportingUtil from '../../util/PayrollReportingUtil_MSF';

export default [function () {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {},
        controller: ['$filter', '$scope', 'policy.PolicyService', 'PolicyService', 'CancellationService', '$stateParams', '$state', '$timeout', 'quoteService', '$rootScope', 'ModalService', function ($filter, $scope, PolicyService, GatewayPolicyService, CancellationService, $stateParams, $state, $timeout, QuoteService, $rootScope, ModalService) {

            //Defining Errors
            $scope.jobNumber = $stateParams.jobNumber;
            $scope.totalClicked = false;
            $scope.edit = true;
            if ($stateParams.viewOnly === 'true') {
                $scope.edit = false;
            }
            /**
             * Function to Monitor event fullTimePerCapitaEmployees
             * @params{String, object, object}
             * @returns{Array} - returns a list of full time per capita employees  and populates $scope.fullTimePerCapitaList
             * @private
              **/
            $scope.$on('fullTimePerCapitaEmployees', function (event, employeeList) {

                $scope.fullTimePerCapitaList = [];
                angular.forEach(employeeList, function (emp) {

                    var start = new Date(emp.startDate.year, emp.startDate.month, emp.startDate.day);
                    var end = new Date(emp.endDate.year, emp.endDate.month, emp.endDate.day);
                    var row = {};
                    row.id = "0913";
                    row.startDate = start;
                    row.endDate = end;
                    row.name = emp.name;
                    row.days = emp.days;
                    row.type = emp.type;
                    row.reportedPerCapita = emp.reportedPerCapita;
                    //setting up editable boolean values
                    row.isReportedEditable = emp.isReportedEditable != null ? emp.isReportedEditable : true;
                    row.isNameEditable = emp.isNameEditable != null ? emp.isNameEditable : true;
                    row.isStartDateEditable = emp.isStartDateEditable != null ? emp.isStartDateEditable : true;
                    row.isEndDateEditable = emp.isEndDateEditable != null ? emp.isEndDateEditable : true;
                    $scope.fullTimePerCapitaList.push(row);
                }); //End of employeeList For Loop
            }); // End of On fullTimePerCapitaEmployees
            /**
            * Function to Monitor event partTimePerCapitaEmployees
            * @params{String, object, object}
            * @returns{Array} - returns a list of part time per capita employees  and populates $scope.partTimePerCapitaList
            * @private
             **/
            $scope.$on('partTimePerCapitaEmployees', function (event, employeeList) {
                $scope.partTimePerCapitaList = [];

                angular.forEach(employeeList, function (emp) {

                    var start = new Date(emp.startDate.year, emp.startDate.month, emp.startDate.day);
                    var end = new Date(emp.endDate.year, emp.endDate.month, emp.endDate.day);
                    var row = {};
                    row.id = "0908";
                    row.startDate = start;
                    row.endDate = end;
                    row.name = emp.name;
                    row.totalHours = emp.totalHours;
                    row.days = emp.days;
                    row.type = emp.type;
                    //setting up editable boolean values
                    row.isReportedEditable = emp.isReportedEditable != null ? emp.isReportedEditable : true;
                    row.isNameEditable = emp.isNameEditable != null ? emp.isNameEditable : true;
                    row.isStartDateEditable = emp.isStartDateEditable != null ? emp.isStartDateEditable : true;
                    row.isEndDateEditable = emp.isEndDateEditable != null ? emp.isEndDateEditable : true;
                    $scope.partTimePerCapitaList.push(row);
                });
            }); //End of On partTimePerCapitaEmployees
            /**
             * Function to Monitor event closePartTimeCapita
             * @params{String}
             * @returns{Array} - returns a list of part time per capita employees  and populates $scope.partTimePerCapitaList
             * @private
              **/
            $scope.$on('closePartTimeCapita', function () {
                $scope.partTimeCapita = false;
                $scope.closeValidateScreen = false;
                $scope.partTimeCapitaEntered = true;
                $state.reload();
            }); //close Full time capita screen	empty data
            $scope.$on('closeFullTimeCapitaEmpty', function () {
                $scope.fullTimeCapita = false;
                $scope.closeValidateScreen = false;
                $scope.fullTimeCapitaEntered = false;

                $state.reload();
            }); //End of closePartTimeCapita

            /**
              * Function to Monitor event closePartTimeCapitaEmpty
              * @params{String}
              * @returns{Array} - returns a list of part time per capita employees  and populates $scope.partTimePerCapitaList
              * @private
               **/
            $scope.$on('closePartTimeCapitaEmpty', function () {
                $scope.partTimeCapita = false;
                $scope.closeValidateScreen = false;
                $scope.partTimeCapitaEntered = false;
                $state.reload();
            });

            /**
            * Function to validate percapita entered for final payroll report
            * @params{void}
            * @returns{boolean}
            * @private
            **/
            $scope.perCapitaValidation = function () {
                if ($scope.lastReport && $scope.perCapitaInfo) {
                    if ($scope.partTimePerCapitaPresent) {
                        if ($scope.partTimeCapitaEntered) {
                            return true;
                        } else {
                            return false;
                        }
                    }
                    if ($scope.fullTimePerCapitaPresent) {
                        if ($scope.fullTimeCapitaEntered) {
                            return true;
                        } else {
                            return false;
                        }
                    }
                } else {
                    return true;
                }
            }; // End of perCapitaValidation

            /**
            * Function to Monitor event closeFullTimeCapita
            * @params{String}
            * @returns{void}
            * @private
            **/
            $scope.$on('closeFullTimeCapita', function () {
                $scope.fullTimeCapita = false;
                $scope.closeValidateScreen = false;
                $scope.fullTimeCapitaEntered = true;
                $state.reload();
            });

            /**
            * Function to check last report by JobNumber
            * @params{String} - jobNumber
            * @returns{Object} - updates $scope.lastReport variable
            * @private
            **/
            PolicyService.checkLastReport($scope.jobNumber).then(function (data) {
                $scope.lastReport = data;
            });

            /**
             * Setting up the verification total amount to specific format
             */
            $scope.verificationTotal = function (verificationTotalAmount) {

                if (verificationTotalAmount) {
                    $scope.auditPayrollResults.verificationTotal.amount = parseFloat(verificationTotalAmount).toFixed(2);
                    PolicyService.getCurrency().then(function (resp) {
                        $scope.auditPayrollResults.verificationTotal.currency = resp;
                    });
                } else {
                    var value = document.getElementById('verificationInput').value;
                    if (value && value != '') {
                        value = value.replace(/[, ]+/g, "").trim();
                        value = value.replace('$', '');
                        value = parseFloat(value).toFixed(2);
                        PolicyService.getCurrency().then(function (resp) {
                            $scope.currency = resp;
                            if ($scope.currency) {
                                $scope.auditPayrollResults.verificationTotal = { amount: value, currency: $scope.currency };
                            }
                        });
                    }
                }
            };

            /**
            * Function to check any errors on the form being submitted.
            * @params{}
            * @returns{void} - populates $scope.errorAvailable
            * @private
             **/
            $scope.checkFormErrors = function () {
                $scope.errorAvailable = PayrollReportingUtil.checkFormErrors($scope.formErrors);
                return $scope.errorAvailable;
            }; //End of checkFormErrors

            /**
            * Function to get part per capita records
            * @params{Object, Object} - item, payrollData
            * @returns{Array} - populates $scope.perCapitaRecords
            * @private
            **/
            $scope.getPartPerCapitaRecords = function (item, payrollData) {
                $scope.perCapitaRecords = [];

                if ($scope.auditPayrollResults.payrollData) {
                    angular.forEach($scope.auditPayrollResults.payrollData, function (currentPayroll, payrollKey) {
                        if (currentPayroll.partTime) {

                            /**
                             * checking each record with other records whether we have a match with high rating period
                             * if so we don't need to push it
                             */
                            $scope.partTimeMatch = PayrollReportingUtil.checkPartTimePayrollMatch($scope.auditPayrollResults.payrollData, currentPayroll);

                            /**
                             * Push all other items which are not falling into the above case
                             */
                            if (!$scope.partTimeMatch) {

                                angular.forEach(currentPayroll.partTime, function (partTime, partTimeKey) {

                                    $scope.perCapitaRecords.push(partTime);
                                });
                            }
                        }
                    });
                }
                $scope.partTimeRecordReady = true;

                return $scope.perCapitaRecords;
            }; // End of getPartPerCapitaRecords

            /**
             * Function to get full time per capita records
             * @params{Object, Object} - item, payrollData.
             * @returns{boolean} - updates $scope.fullPerCapitaRecords variable
             * @private
             **/
            $scope.getFullPerCapitaRecords = function (item, payrollData) {
                $scope.fullPerCapitaRecords = [];

                if ($scope.auditPayrollResults.payrollData) {
                    angular.forEach($scope.auditPayrollResults.payrollData, function (currentPayroll, payrollKey) {
                        if (currentPayroll.fullTime) {

                            /**
                             * checking each record with other records whether we have a match with high rating period
                             * if so we don't need to push it
                             */
                            $scope.fullTimeMatch = PayrollReportingUtil.checkFullTimePayrollMatch($scope.auditPayrollResults.payrollData, currentPayroll);

                            /**
                             * Push all other items which are not falling into the above case
                             */
                            if (!$scope.fullTimeMatch) {

                                angular.forEach(currentPayroll.fullTime, function (fullTime, fullTimeKey) {

                                    $scope.fullPerCapitaRecords.push(fullTime);
                                });
                            }
                        }
                    });
                }
                $scope.fullTimeRecordReady = true;

                return $scope.fullPerCapitaRecords;
            };

            /**
             * Function to get perCapitalClassCodes by JobNumber
             * @params{jobNumber}
             * @returns{Array}
             * @private
             **/
            PolicyService.getPerCapitaCodesByJobNumber($scope.jobNumber).then(function (perCapitaClassCodesFullData) {
                $scope.perCapitaClasses = PayrollReportingUtil.getClassCodesArray(perCapitaClassCodesFullData);
            }); //End of getPerCapitaCodesByJobNumber

            var auditPayrollDataPromise = PolicyService.getPayrollDataForPeriod($scope.jobNumber).then(function (res) {
                $scope.auditPayrollResults = res;

                //ACR 18624 - modifiying period end date for display purposes only
                $scope.auditPayrollResultsBackup = JSON.parse(JSON.stringify($scope.auditPayrollResults));

                angular.forEach($scope.auditPayrollResults.payrollData, function (result) {
                    var dateStr = result.ratingExpiredDate;
                    var date = new Date(dateStr);
                    date.setDate(date.getDate() - 1);
                    var newDateStr = date.toISOString();
                    result.ratingExpiredDate = newDateStr;
                });

                var dateStr = res.periodEnd;
                var date = new Date(dateStr);
                date.setDate(date.getDate() - 1);
                var newDateStr = date.toISOString();
                $scope.auditPayrollResults.periodEnd = newDateStr;

                //If back button is used the payroll may be complete, do not let them enter again
                if ($scope.auditPayrollResults.isReversed) {
                    $scope.hideForm();
                }

                var currentDate = PolicyService.getCurrentDate();
                currentDate.then(function (res) {
                    var splited_currentDate = res.match(/(\d+)/g);
                    $scope.today = new Date(splited_currentDate[0], splited_currentDate[1] - 1, splited_currentDate[2], splited_currentDate[3], splited_currentDate[4], splited_currentDate[5]);
                });
                if ($scope.auditPayrollResults.verificationTotal != null && $scope.auditPayrollResults.verificationTotal != '' && $scope.auditPayrollResults.verificationTotal != 0) {
                    $scope.auditPayrollResults.verificationTotal.amount = $scope.auditPayrollResults.verificationTotal.amount.toFixed(2);
                }
                if ($scope.auditPayrollResults.payrollData) {
                    $scope.formErrors = [];
                    $scope.count = 0;
                    $scope.estimatedPerCapita_count = 0;
                    angular.forEach($scope.auditPayrollResults.payrollData, function (result) {
                        if (result.classCode == "0913") {
                            $scope.perCapitaCodePresent = true;
                            $scope.perCapitaInfo = true;
                            $scope.fullTimePerCapitaPresent = true;
                            $scope.eType = result.earningsType;
                            PolicyService.getFullTimePerCapita($stateParams.jobNumber, result.earningsType, result.classCode, result.location, result.personsCovered).then(function (res) {
                                result['fullTime'] = res;
                                if (res != []) {
                                    //display percapita records in parent screen
                                    $scope.getFullPerCapitaRecords(result, $scope.auditPayrollResults.payrollData);

                                    if ($scope.fullPerCapitaRecords) {
                                        $scope.fullTimeRecordReady = true;
                                    }
                                }
                                if (res != undefined && res.length > 0) {
                                    $scope.fullTimeCapitaEntered = true;
                                }
                            });
                        } else if (result.classCode == "0908") {
                            $scope.perCapitaCodePresent = true;
                            $scope.perCapitaInfo = true;
                            $scope.partTimePerCapitaPresent = true;
                            $scope.eType = result.earningsType;
                            PolicyService.getPartTimePerCapita($stateParams.jobNumber, result.earningsType, result.classCode, result.location, result.personsCovered).then(function (res) {
                                result['partTime'] = res;
                                if (res != []) {
                                    //display percapita records in parent screen
                                    $scope.getPartPerCapitaRecords(result, $scope.auditPayrollResults.payrollData);

                                    if ($scope.perCapitaRecords) {
                                        $scope.partTimeRecordReady = true;
                                    }
                                }
                                if (res != undefined && res.length > 0) {
                                    $scope.partTimeCapitaEntered = true;
                                }
                            });
                        }
                        if (result.estimatedPayroll.amount) {
                            $scope.count = $scope.count + result.estimatedPayroll.amount;
                        }
                        if (result.reportedPayroll != null && result.reportedPayroll != '') {
                            result.reportedPayroll.amount = result.reportedPayroll.amount.toFixed(2);
                        }
                        if (result.reportedPerCapita != null && result.reportedPerCapita != '') {
                            result.reportedPerCapita = result.reportedPerCapita;
                        }
                        if (result.estimatedPerCapita) {
                            $scope.estimatedPerCapita_count = $scope.estimatedPerCapita_count + result.estimatedPerCapita;
                        }
                    });
                    $scope.getTotal();
                    $scope.getCapitaTotal();
                }
            }, function (error) {}); //End of AuditDataPayrollPromise

            /**
             * Function to retrieve total reported payroll amounts Total from Reports.
             * @param{void}
             * @returns{Decimal} - tot_reported_payroll_amount variable set
             & @private
             **/
            $scope.tot_reported_payroll_amount = 0;
            $scope.getTotal = function () {
                if ($scope.auditPayrollResults) {
                    $scope.tot_reported_payroll_amount = null;
                    angular.forEach($scope.auditPayrollResults.payrollData, function (result) {
                        if (result.reportedPayroll && JSON.stringify(result.reportedPayroll) != '{}' && result.reportedPayroll.amount != '') {
                            if ($scope.tot_reported_payroll_amount == null) $scope.tot_reported_payroll_amount = parseFloat(result.reportedPayroll.amount);else $scope.tot_reported_payroll_amount = $scope.tot_reported_payroll_amount + parseFloat(result.reportedPayroll.amount);
                        }
                    });
                }
            };
            /**
            * Function to retrieve perCapita Total from Reports.
            * @param{}
            * @returns{Decimal} - total_perCapita_amt variable set
            & @private
            **/
            $scope.tot_percapita_amount = 0;
            $scope.getCapitaTotal = function () {
                if ($scope.auditPayrollResults) {
                    $scope.tot_percapita_amount = null;
                    angular.forEach($scope.auditPayrollResults.payrollData, function (result) {
                        if (result.reportedPerCapita !== undefined && result.reportedPerCapita !== '' && result.reportedPerCapita != null || result.reportedPerCapita === 0) {
                            if ($scope.tot_percapita_amount == null) {
                                $scope.tot_percapita_amount = parseInt(result.reportedPerCapita);
                            } else {
                                $scope.tot_percapita_amount = $scope.tot_percapita_amount + parseInt(result.reportedPerCapita);
                            }
                        }
                    });
                }
            };
            /**
             * Function to set focus on text element
             * @params{int} - selected index / element
             * @returns{Object} - sets focus on myText HTML element.
             * @private
             **/
            $scope.myFunction = function (index) {
                $scope.enabledEdit = [];
                $scope.enabledEdit[index] = true;
                $scope.clicked = true;
                $timeout(function () {
                    angular.element('#myTxt').focus();
                });
            };
            /**
                 * Function to set focus on selected capita element
                 * @params{int} - selected index / element
                 * @returns{Object} - sets focus on capita HTML element.
                 * @private
                 **/
            $scope.reportedPerCapita = function (index) {
                $scope.enabledEditCapita = [];
                $scope.enabledEditCapita[index] = true;
                $timeout(function () {
                    angular.element('#capita').focus();
                });
            };
            /**
             * Function to update verification total based on user input in the verificationInput HTML element.
             * @params{String} - status - edit or insert
             * @returns{void} - updates  $scope.auditPayrollResults.verificationTotal values.
             * @private
             **/
            $scope.changeTotalClick = function (status) {
                if (status == 'edit') {
                    $scope.totalClicked = true;
                    $timeout(function () {
                        angular.element('#verificationInput').focus();
                    });
                } else {
                    var value = angular.element('#verificationInput').val();
                    if (parseFloat(value) == 0) {
                        $scope.auditPayrollResults.verificationTotal.amount = value;
                        PolicyService.getCurrency().then(function (resp) {
                            $scope.auditPayrollResults.verificationTotal.currency = resp;
                        });
                    }
                    if (value.length == 0) {
                        delete $scope.auditPayrollResults.verificationTotal;
                    }
                    if (value.length > 16) {
                        $scope.errMsg = "Can have no more than 16 digits to the left of the decimal point.";
                        return true;
                    } else {
                        $scope.errMsg = false;
                        $scope.totalClicked = false;
                        if (value && value != '') {
                            value = value.replace(/[, ]+/g, "").trim();
                            value = value.replace('$', '');
                            value = parseFloat(value).toFixed(2);
                            PolicyService.getCurrency().then(function (resp) {
                                $scope.auditPayrollResults.verificationTotal = { amount: value, currency: resp };
                            });
                        }
                    }
                }
            };
            /**
            * Function to update furloughted total based on user input in the furloughedWages HTML element.
            * @params{String} - status - edit or insert
            * @returns{void} - updates  $scope.auditPayrollResults.furloughedWages values.
            * @private
            **/
            $scope.furloughedClick = function (status) {
                if (status == 'edit') {
                    $scope.totalClicked = true;
                    $timeout(function () {
                        angular.element('#furloughedWages').focus();
                    });
                } else {
                    var value = angular.element('#furloughedWages').val();
                    if (parseFloat(value) == 0) {
                        $scope.auditPayrollResults.furloughedWages.amount = value;
                        PolicyService.getCurrency().then(function (resp) {
                            $scope.auditPayrollResults.furloughedWages.currency = resp;
                        });
                    }
                    if (value.length == 0) {
                        delete $scope.auditPayrollResults.furloughedWages;
                    } else {
                        $scope.errMsg = false;
                        $scope.totalClicked = false;
                        if (value && value != '') {
                            value = value.replace(/[, ]+/g, "").trim();
                            value = value.replace('$', '');
                            value = parseFloat(value).toFixed(2);
                            PolicyService.getCurrency().then(function (resp) {
                                $scope.auditPayrollResults.furloughedWages = { amount: value, currency: resp };
                            });
                        }
                    }
                }
            };
            /**
                     * Function to update and validate verification Total values based on passed amounts
                     * @params{Decimal} - verification Total
                     * @returns{void} - updates  $scope.auditPayrollResults.verificationTotal & scope.amount values.
                     * @private
                     **/
            $scope.verification = function (verification_total) {
                if (verification_total) {
                    if (verification_total.match(/^\$/) == null) {
                        $scope.amount = $filter('currency')(verification_total);
                    } else {
                        $scope.amount = verification_total;
                    }
                    $scope.auditPayrollResults.verificationTotal = $scope.amount;
                }
            };
            /**
            * Function to get totals for each item of payroll
            * @params{Object, int} - item, index
            * @returns{void} - updates auditPayrollResult's reported payroll values based on passed in values.
            * @private
            **/
            $scope.estimatedReport = function (item, index) {
                if (item.reportedPayroll && item.reportedPayroll.amount != undefined && item.reportedPayroll.amount.length == 0) {
                    delete item.reportedPayroll;
                } else {
                    if (item.reportedPayroll && item.reportedPayroll.amount) {
                        $scope.auditPayrollResults.payrollData[index].reportedPayroll.amount = parseFloat(item.reportedPayroll.amount).toFixed(2);
                        PolicyService.getCurrency().then(function (resp) {
                            $scope.auditPayrollResults.payrollData[index].reportedPayroll.currency = resp;
                        });
                    } else {
                        var value = document.getElementById('myTxt' + index).value;
                        if (value && value != '') {
                            value = value.replace(/[, ]+/g, "").trim();
                            value = value.replace('$', '');
                            value = parseFloat(value).toFixed(2);
                            PolicyService.getCurrency().then(function (resp) {
                                $scope.currency = resp;
                                if ($scope.currency) {
                                    $scope.auditPayrollResults.payrollData[index].reportedPayroll = { amount: value, currency: $scope.currency };
                                    $scope.getTotal();
                                }
                            });
                        }
                    }
                }
            };
            /**
               * Function update estimated reported per capita value based on selected Payroll inext
               * @params{Object, int} - item, index
               * @returns{void} - updates auditPayrollResult's reported per capita values based on selected item
               * @private
               **/
            $scope.estimatedreportPerCapita = function (item, index) {
                if (item.reportedPerCapita.length == 0) {
                    delete item.reportedPerCapita;
                }
                if (item.reportedPerCapita == 0) {
                    $scope.auditPayrollResults.payrollData[index].reportedPerCapita = parseInt(item.reportedPerCapita);
                }
            };
            /**
               * Function restrict user key strokes from UI Screen.
               * @params{event}
               * @returns{boolean}
               * @private
               **/
            $scope.restrictAlphabets = function (event) {
                PayrollReportingUtil.restrictAlphabets(event);
            };

            /**
                 * Function to hide/cancel functionality and navigate to payroll details view
                 * @params{void}
                 * @returns{void}
                 * @private
                  **/
            $scope.hideForm = function () {
                $state.go('payroll-details', {
                    policyNumber: $scope.auditPayrollResults.policyNumber
                });
            };
            /**
            * Function to navigate to policy summary view
            * @params{void}
            * @returns{void}
            * @private
             **/
            $scope.policysummaryForm = function () {
                $state.go('policies.detail.summary', {
                    policyNumber: $scope.auditPayrollResults.policyNumber
                });
            };

            /**
              * Function to save Payroll data
              * @params{Object, Object} - payRollForm, auditPayroll results.
              * @returns{void} -calls service to save payroll information to backend systems.
              * @private
               **/
            $scope.savePayroll = function (PayrollForm, auditPayrollResults) {
                $scope.array_length = auditPayrollResults.payrollData.length;
                angular.forEach(auditPayrollResults.payrollData, function (result, rkey) {
                    if (auditPayrollResults) {
                        var pattern = /[^0-9.-]+/g;
                        $scope.checkVerificationTotAmount(auditPayrollResults);
                        $scope.checkReportedPayrollAmount(auditPayrollResults);
                        //calling save service
                        PolicyService.savePayrollReportData($scope.jobNumber, auditPayrollResults).then(function (data) {
                            $scope.hideForm();
                        });
                    }
                });
            };

            /**
            * Function that toggles between perCapita and Enter and Validate Screen
            * @params{ String, String, Object, Object} - code,type,PayrollForm,auditPayrollResults
            * @returns{}
            * @private
             **/
            $scope.showPerCapitaScreen = function (code, type, PayrollForm, auditPayrollResults) {
                $scope.array_length = auditPayrollResults.payrollData.length;
                angular.forEach(auditPayrollResults.payrollData, function (result, rkey) {
                    if (auditPayrollResults) {
                        var pattern = /[^0-9.-]+/g;
                        $scope.checkVerificationTotAmount(auditPayrollResults);
                        if (result.reportedPayroll && result.reportedPayroll.amount && !result.reportedPayroll.currency) {
                            PolicyService.getCurrency().then(function (resp) {
                                auditPayrollResults.payrollData[rkey].reportedPayroll.currency = resp;
                            });
                            auditPayrollResults.payrollData[rkey].reportedPayroll.amount = parseInt(result.reportedPayroll.amount);
                        }
                        //calling save service
                        PolicyService.savePayrollReportData($scope.jobNumber, auditPayrollResults).then(function (data) {});
                    }
                });
                $scope.partTimeCapitaEntered = false;
                $scope.fullTimeCapitaEntered = false;
                if (code == "0908") {
                    $scope.partTimeCapita = true;
                    $scope.closeValidateScreen = true;
                } else if (code == "0913") {
                    $scope.fullTimeCapita = true;
                    $scope.closeValidateScreen = true;
                }
                $scope.eType = type;
            };

            /**
                      * Function that to initialize scope variables
                      * display error message when perCapita class code value is not entered  
                      * @params {array} - auditPayrollResults.
                      * @ returns {None} 
                      * @ private
                      **/
            $scope.initializeScopeVariables = function (auditPayrollResults) {
                $scope.perCapitaError = false;
                if ($scope.perCapitaValidation() == false) {
                    $scope.perCapitaError = true;
                    return false;
                }
                if ($scope.changeTotalClick('display') == true) {
                    $scope.totalClicked = true;
                    $scope.verification_required = false;
                    return false;
                }
                $scope.disableSubmit = true;
                $scope.verification_required = false;
                $scope.owner_reported_payroll = false;
                $scope.reported_payroll = false;
                $scope.verification_invalid = false;
                $scope.reported_per_capita = false;
                $scope.formErrors = [];
                $scope.ownerErrors = [];
                $scope.array_length = auditPayrollResults.payrollData.length;

                auditPayrollResults.firstName = $rootScope.authData.userData.given_name;
                auditPayrollResults.lastName = $rootScope.authData.userData.family_name;
            };

            /**
             * Function that to validate verification total and total reported payroll amount 
             * display error message when total reported payroll amount is greater than 25  
             * @params {array, Object} - auditPayrollResults, result.
             * @ returns {None} 
             * @ private
             **/
            $scope.validateVerificationTotal = function (auditPayrollResults, result) {
                if (!auditPayrollResults.verificationTotal && result.reportedPayroll && result.reportedPayroll.amount || auditPayrollResults.verificationTotal && result.reportedPayroll && result.reportedPayroll.amount == "") {
                    if ($scope.tot_reported_payroll_amount > 25 || !isNaN($scope.tot_reported_payroll_amount) && $scope.tot_reported_payroll_amount < 0) {
                        $scope.verification_invalid = true;
                        $scope.disableSubmit = false;
                        $scope.owner_reported_payroll = false;

                        $scope.reported_payroll = false;
                    }
                }
                if (!auditPayrollResults.verificationTotal) {
                    $scope.verification_required = true;
                    $scope.disableSubmit = false;
                    $scope.owner_reported_payroll = false;
                } else {
                    $scope.verification_required = false;
                }
            };

            /**
             * Function that to format verification total amount into currency  
             * @params {array} - auditPayrollResults.
             * @ returns {None} 
             * @ private
             **/
            $scope.currencyFormat = function (auditPayrollResults) {
                $scope.checkVerificationTotAmount(auditPayrollResults);
                if ($scope.tot_reported_payroll_amount === auditPayrollResults.verificationTotal.amount) {

                    $scope.verification_invalid = false;
                    $scope.owner_reported_payroll = false;
                } else {
                    $scope.disableSubmit = false;
                    $scope.owner_reported_payroll = false;
                }
            };

            /**
             * Function that to validate verification total and total reported payroll amount and display error message  
             * @params {Object, array, key} - result, auditPayrollResults, rkey.
             * @ returns {None} 
             * @ private
             **/
            $scope.validateOtherPayrollReports = function (result, auditPayrollResults, rkey) {
                if (result.reportedPerCapita) auditPayrollResults.payrollData[rkey].reportedPerCapita = parseInt(result.reportedPerCapita);
                $scope.checkVerificationTotAmount(auditPayrollResults);
                if ($scope.tot_reported_payroll_amount === auditPayrollResults.verificationTotal.amount) {

                    $scope.verification_invalid = false;
                } else {
                    $scope.disableSubmit = false;
                    $scope.owner_reported_payroll = false;
                }
            };

            /**
             * Function that to display error message when reported payroll value is missed 
             * @params {Object} - result.
             * @ returns {None} 
             * @ private
             **/
            $scope.formErrorMessage = function (result) {
                var formError = {
                    reportedPayroll: { status: false, message: 'Please use Reported Payroll for this Class Code', classCode: result.classCode }
                };
                $scope.formErrors.push(formError);
                $scope.reported_payroll = true;
                $scope.disableSubmit = false;
                $scope.verification_required = false;
            };

            /**
             * Function to check the verification total amount in currency format or not
             * getCurrency service call is used to get the usd format of the currency
             * @params {Array} -  auditPayrollResults
             * @returns {void}
             */
            $scope.checkVerificationTotAmount = function (auditPayrollResults) {
                if (auditPayrollResults.verificationTotal && auditPayrollResults.verificationTotal.amount) {
                    if (!auditPayrollResults.verificationTotal.currency) {
                        PolicyService.getCurrency().then(function (resp) {
                            auditPayrollResults.verificationTotal.currency = resp;
                        });
                        auditPayrollResults.verificationTotal.amount = parseFloat(auditPayrollResults.verificationTotal.amount);
                    } else {
                        auditPayrollResults.verificationTotal.amount = parseFloat(auditPayrollResults.verificationTotal.amount);
                    }
                }
            };

            /**
             * Function to check the reported payroll amount in currency format or not
             * getCurrency service call is used to get the usd format of the currency
             * @params {Array} -  auditPayrollResults
             * @returns {void}
             */
            $scope.checkReportedPayrollAmount = function (auditPayrollResults, result, rkey) {
                if (result.reportedPayroll && result.reportedPayroll.amount) {
                    if (!result.reportedPayroll.currency) {
                        PolicyService.getCurrency().then(function (resp) {
                            auditPayrollResults.payrollData[rkey].reportedPayroll.currency = resp;
                        });

                        auditPayrollResults.payrollData[rkey].reportedPayroll.amount = parseFloat(result.reportedPayroll.amount);
                    } else auditPayrollResults.payrollData[rkey].reportedPayroll.amount = parseFloat(result.reportedPayroll.amount);
                }
            };

            /**
             * Function for validating reported payroll field for payroll data
             * Display error message when verification total difference is more than 25 from reported payroll total                     
             * @params{Object, Object, key} -  auditPayrollResults, result, rkey
             * @returns{void}
             * @private
              **/
            $scope.validateReportedVal = function (result, auditPayrollResults, rkey) {
                if ($scope.verification_diff_value > 25 || !isNaN($scope.verification_diff_value) && $scope.verification_diff_value < 0) {
                    $scope.verification_invalid = true;
                    $scope.disableSubmit = false;
                    $scope.verification_required = false;
                    $scope.reported_payroll = false;
                    $scope.owner_reported_payroll = false;
                    if (result.personsCovered != "ALL OTHER EMPLOYEES" && result.earningsType != "Employees") {

                        $scope.owner_reported_payroll = false;
                        $scope.checkReportedPayrollAmount(auditPayrollResults, result, rkey);
                    }
                } else {
                    if ($scope.verification_diff_value < 25 || !isNaN($scope.verification_diff_value) && $scope.verification_diff_value < 0) {
                        if (result.personsCovered != "ALL OTHER EMPLOYEES" && result.earningsType != "Employees") {

                            $scope.owner_reported_payroll = false;
                            $scope.checkReportedPayrollAmount(auditPayrollResults, result, rkey);
                            $scope.verification_invalid = false;
                            $scope.owner_reported_payroll = false;
                            $scope.checkVerificationTotAmount(auditPayrollResults);
                            $scope.checkReportedPayrollAmount(auditPayrollResults, result, rkey);
                        }
                    }
                    $scope.verification_invalid = false;
                    $scope.checkVerificationTotAmount(auditPayrollResults);
                    $scope.checkReportedPayrollAmount(auditPayrollResults, result, rkey);
                }
            };

            /**
             * Function for validating all fields for payroll data
             * Validating verification total field
             * Check whether the payroll is last report or not
             * Validate last payrol report for both part time class code and full time class code
             * Validate payroll othe than last report
             * @params{Object, Object, key} -  auditPayrollResults, result, rkey
             * @returns{void}
             * @private
              **/
            $scope.validateEditPayroll = function (auditPayrollResults, result, rkey) {
                $scope.validateVerificationTotal(auditPayrollResults, result);
                if (auditPayrollResults.verificationTotal && (auditPayrollResults.verificationTotal.amount == 0 || auditPayrollResults.verificationTotal.amount != 0)) {
                    $scope.classCode_result = $scope.perCapitaClasses.includes(result.classCode);

                    if ($scope.classCode_result) {
                        if ($scope.lastReport == true) {
                            //service call code goes here
                            if (result.reportedPerCapita) {
                                auditPayrollResults.payrollData[rkey].reportedPerCapita = parseInt(result.reportedPerCapita);
                            }

                            $scope.currencyFormat(auditPayrollResults);
                        } else {
                            $scope.validateOtherPayrollReports(result, auditPayrollResults, rkey);
                        }
                    } else {
                        if ($scope.lastReport == true || $scope.lastReport == false) {
                            if (!result.reportedPayroll) {
                                //setting up errors
                                $scope.formErrorMessage(result);
                                if (result.personsCovered != "ALL OTHER EMPLOYEES" && result.earningsType != "Employees") {}
                            } else {
                                $scope.verification_invalid = false;
                                var pattern = /[^0-9.-]+/g;

                                if ((result.reportedPayroll && result.reportedPayroll.amount == 0 || result.reportedPayroll.amount != 0) && (auditPayrollResults.verificationTotal && auditPayrollResults.verificationTotal.amount == 0 || auditPayrollResults.verificationTotal.amount != 0)) {

                                    $scope.verification_diff_value = Number(Math.abs($scope.tot_reported_payroll_amount - auditPayrollResults.verificationTotal.amount));

                                    $scope.validateReportedVal(result, auditPayrollResults, rkey);
                                }
                            }
                        }
                    }
                }
            };

            /**
             * Function that Update and submit payroll Report data 
             * @params {String, Array, boolean} - newly created Job Number, auditPayRollResults, true or false.
             * @ returns {None} - navigate to payroll submit view.
             * @ private
             **/
            $scope.submitOneTimePayrollReportData = function (newlyCreatedJob, auditPayrollResults, payrollEdit) {
                PolicyService.submitOneTimePayrollReportData(newlyCreatedJob, auditPayrollResults, payrollEdit).then(function (data) {
                    GatewayPolicyService.callEUTS('Edit Payroll Report', 'Submit Payroll', $scope.auditPayrollResults.policyNumber, 'Submitted Edited Payroll Report');
                    $state.go('payroll-submit', {
                        jobNumber: newlyCreatedJob
                    });
                }, function (error) {
                    if (error.baseError && error.baseError.error && typeof error.baseError.error === "string" && error.baseError.error.includes("502")) {
                        $scope.disableSubmit = true;
                        PolicyService.getAuditStatus(newlyCreatedJob, auditPayrollResults).then(function (response) {

                            if (response == true) {
                                $state.go('payroll-submit', {
                                    jobNumber: newlyCreatedJob
                                });
                            }
                        });
                    }
                    //Handling other errors
                    if (error.baseError.error && error.baseError.error.message) {
                        $scope.disableSubmit = false;
                        ModalService.showError('', PayrollReportingUtil.structuredError(error.baseError.error.message));
                    } else {
                        if (error.message) {
                            $scope.disableSubmit = false;
                            ModalService.showError('', PayrollReportingUtil.structuredError(error.message));
                        }
                    }
                });
            };

            /**
             * Function that submits payroll Report data for prior term payroll
             * @params {Object, Array, boolean} - Job, auditPayRollResults, true or false.
             * @ returns {None} - navigate to payroll submit view.
             * @ private
             **/
            $scope.submitCompletedReports = function (response, auditPayrollResults) {
                angular.forEach(response.completedReports, function (result, skey) {
                    if (result.periodStart == $scope.auditPayrollResults.periodStart) {
                        if (result.status == 'In Progress') {
                            $scope.payrollEdit = true;
                            $scope.newlyCreatedJob = result.jobNumber;
                            //update before submitting
                            if ($scope.lastReport && $scope.perCapitaInfo && ($scope.partTimePerCapitaPresent && $scope.partTimeCapitaEntered || $scope.fullTimePerCapitaPresent && $scope.fullTimeCapitaEntered)) {
                                if ($scope.partTimePerCapitaPresent && $scope.partTimeCapitaEntered) {
                                    if ($scope.fullTimePerCapitaPresent && $scope.fullTimeCapitaEntered) {
                                        $scope.submitOneTimePayrollReportData($scope.newlyCreatedJob, auditPayrollResults, $scope.payrollEdit);
                                    } else {
                                        $scope.submitOneTimePayrollReportData($scope.newlyCreatedJob, auditPayrollResults, $scope.payrollEdit);
                                    }
                                } else {
                                    $scope.submitOneTimePayrollReportData($scope.newlyCreatedJob, auditPayrollResults, $scope.payrollEdit);
                                }
                            } //last report for completed record
                            else {
                                    $scope.submitOneTimePayrollReportData($scope.newlyCreatedJob, auditPayrollResults, $scope.payrollEdit);
                                }
                        }
                    }
                });
            };

            /**
             * Function that submits payroll Report data for current term
             * @params {Object, Array, boolean} - Job, auditPayRollResults, true or false.
             * @ returns {None} - navigate to payroll submit view.
             * @ private
             **/
            $scope.submitScheduledReports = function (response, auditPayrollResults) {
                angular.forEach(response.scheduledReports, function (result, skey) {
                    if (result.periodStart == $scope.auditPayrollResults.periodStart) {
                        if (result.status == 'In Progress') {
                            $scope.newlyCreatedJob = result.jobNumber;
                            $scope.payrollEdit = true;
                            //update before submitting
                            if ($scope.lastReport && $scope.perCapitaInfo && ($scope.partTimePerCapitaPresent && $scope.partTimeCapitaEntered || $scope.fullTimePerCapitaPresent && $scope.fullTimeCapitaEntered)) {
                                if ($scope.partTimePerCapitaPresent && $scope.partTimeCapitaEntered) {
                                    if ($scope.fullTimePerCapitaPresent && $scope.fullTimeCapitaEntered) {

                                        //submit onetime payroll report data
                                        $scope.submitOneTimePayrollReportData($scope.newlyCreatedJob, auditPayrollResults, $scope.payrollEdit);
                                    } else {
                                        $scope.submitOneTimePayrollReportData($scope.newlyCreatedJob, auditPayrollResults, $scope.payrollEdit);
                                    }
                                } else {

                                    $scope.submitOneTimePayrollReportData($scope.newlyCreatedJob, auditPayrollResults, $scope.payrollEdit);
                                }
                            } //last report end
                            else {
                                    //submitting payroll without per capita update
                                    $scope.submitOneTimePayrollReportData($scope.newlyCreatedJob, auditPayrollResults, $scope.payrollEdit);
                                }
                        }
                    }
                }); // scheduled reported end
            };

            /**
             * Function for submitting last payroll data
             * Validating reported payroll has owner officer type
             * Check whether any open policy changes are available or not
             * Handling timeout proxy error based on the status code 502
             * @params{Object} -  auditPayrollResults.
             * @returns{void}
             * @private
              **/
            $scope.submitEditPayrollReport = function (auditPayrollResults) {
                var OwnerListPromise = PolicyService.validateOwnerOfficerRepPayroll($scope.jobNumber, auditPayrollResults);
                OwnerListPromise.then(function (data) {
                    if (data != '') {
                        angular.forEach(data, function (res, ownerkey) {
                            $scope.ownerErrors.push(res);
                        });
                        $scope.disableSubmit = false;
                        $scope.owner_reported_payroll = true;
                    } else {
                        $scope.owner_reported_payroll = false;
                        if ($scope.reported_per_capita == false && $scope.verification_invalid == false && $scope.reported_payroll == false && $scope.owner_reported_payroll == false) {
                            $scope.disableSubmit = true;
                            var changePromise = PolicyService.getOpenPolicyChangesForPayroll($scope.jobNumber);
                            changePromise.then(function (res) {
                                $scope.changePolicyData = res;
                                if (res == true) {
                                    $scope.invalidPayroll = true;
                                    $scope.disableSubmit = false;
                                } else {

                                    //ACR 18624 - reversing the end date to actual result from PC
                                    angular.forEach(auditPayrollResults.payrollData, function (result) {
                                        var payRoll = $scope.auditPayrollResultsBackup.payrollData.find(function (a) {
                                            return a.fixedId === result.fixedId && a.ratingDate === result.ratingDate;
                                        });
                                        result.ratingExpiredDate = payRoll.ratingExpiredDate;
                                    });

                                    auditPayrollResults.periodEnd = $scope.auditPayrollResultsBackup.periodEnd;

                                    //calling reverse before submitting new payroll data
                                    var payrollEditDataPromise = PolicyService.editPayrollReport($scope.jobNumber, auditPayrollResults.policyNumber, auditPayrollResults.periodStart, auditPayrollResults.periodEnd, auditPayrollResults);
                                    payrollEditDataPromise.then(function (res) {
                                        //getting all payroll report data after revising the payroll
                                        $scope.payrollReporting = PolicyService.payrollReporting($scope.auditPayrollResults.policyNumber);
                                        $scope.payrollReporting.then(function (response) {
                                            $scope.submitScheduledReports(response, auditPayrollResults);
                                            $scope.submitCompletedReports(response, auditPayrollResults);
                                            PolicyService.createActivityForPortalChanges($scope.auditPayrollResults.policyNumber, auditPayrollResults.periodStart, auditPayrollResults.periodEnd, 'edit');
                                        });
                                    });
                                }
                            });
                        } else {
                            $scope.disableSubmit = false;
                        }
                    }
                });
            };

            /**
            * Function for submitting payroll data
            * @params{Object, Object} - PayrollForm, auditPayrollResults.
            * @returns{void}
            * @private
             **/
            $scope.submitEditPayroll = function (PayrollForm, auditPayrollResults) {
                //Initialize scope variables
                $scope.initializeScopeVariables(auditPayrollResults);
                angular.forEach(auditPayrollResults.payrollData, function (result, rkey) {
                    $scope.sharedClass = result;
                    //Validating field level for all payroll before submitting the payroll
                    $scope.validateEditPayroll(auditPayrollResults, result, rkey);
                    if (rkey == $scope.array_length - 1) {
                        //Complete last payroll by calling submit payroll service
                        $scope.submitEditPayrollReport(auditPayrollResults);
                    }
                });
            };
        }] //End Controller
    }; // End return
}]; // End Export default


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/directives/EditPayrollDirective_MSF/EditPayroll.js
// module id = 1737
// module chunks = 0